import hasAccruedReports from './hasAccruedReports';
import hasCapitalizedFields from './hasCapitalizedFields';
import hasFullName from './hasFullName';
import hasRemedials from './hasRemedials';

const hasTrainingPhases = (phases) => {
  return {
    getTrainingPhases() {
      const doesOpenPhaseExist = phases.find(phase => !!phase.openedAt && !phase.closedAt);
      const nextPendingPhase = doesOpenPhaseExist ? null
        : phases.find(phase => phase.status === 'pending');
      return phases.map((phase) => {
        const getCanAssignFto = () => {
          return phase.type === 'observation' && !phase.fto;
        };
        const hasAccruedEop = phase.accrued.find(report => report.type === 'eop');
        const hasAccruedOrientation = phase.accrued.find(report => report.type === 'tpo');

        const getCanPhaseClose = () => {
          switch (phase.type) {
            case 'observation':
              return (
                phase.status === 'opened' && hasAccruedEop
              );
            case 'orientation':

              return (
                phase.status === 'opened' &&
                (phase.hasAccruedOrientation || phase.hasAccruedEop)
              );
            default:
              return true;
          }
        };
        const getCanPhaseOpen = () => {
          return !nextPendingPhase ? false : phase.guid === nextPendingPhase.guid;
        };
        const getFtoFullName = () => {
          return !phase.fto ? null : `${phase.fto.firstName} ${phase.fto.lastName}`;
        };
        const getIsPhaseOpened = () => {
          return phase.status === 'opened' || phase.status === 'remedial';
        };
        const propertySets = [{
          getCanAssignFto,
          getCanPhaseClose,
          getCanPhaseOpen,
          getIsPhaseOpened,
          trainingPhaseGuid: phase.trainingPhaseGuid,
          header: phase.header,
          openedAt: phase.openedAt,
          sequence: phase.sequence,
          status: phase.status,
          type: phase.type,
          accrued: phase.accrued,
        }];
        if (phase.type === 'observation') {
          propertySets.push({
            fto: phase.fto,
            getFtoFullName,
            hasAccruedEop,
            hasAccruedOrientation,
            remedials: phase.remedials,
            riskAlerts: phase.riskAlerts,
            weeks: phase.weeks,
          });
        }
        return Object.assign(
          {},
          hasAccruedReports(phase.accrued),
          hasCapitalizedFields(phase),
          hasFullName(phase),
          hasRemedials(phase.remedials),
          ...propertySets,
        );
      });
    },
    hasTrainingPhase(phaseToFind) {
      return !!phases.find((phase) => {
        return phase.trainingPhaseGuid === phaseToFind.guid;
      });
    },
  };
};

export default hasTrainingPhases;
